var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2505 27.255L3.07862 27.255C2.30741 27.255 1.6605 26.9886 1.13789 26.4556C0.615281 25.9227 0.354884 25.3009 0.356699 24.5904C0.356699 24.3683 0.39027 24.1347 0.45741 23.8896C0.524551 23.6444 0.627076 23.4117 0.764987 23.1914L14.8509 1.4743C15.1231 1.0746 15.4633 0.774372 15.8716 0.573633C16.2799 0.372894 16.7109 0.273415 17.1645 0.275192C17.6182 0.276968 18.0492 0.376448 18.4574 0.573633C18.8657 0.770821 19.206 1.07104 19.4782 1.4743L33.5641 23.1914C33.7002 23.4135 33.8027 23.6462 33.8717 23.8896C33.9406 24.1329 33.9742 24.3665 33.9724 24.5904C33.9724 25.3009 33.7111 25.9227 33.1885 26.4556C32.6658 26.9886 32.0198 27.255 31.2505 27.255Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront);
export default __webpack_public_path__ + "static/media/front.06df881493215149a668a5793d114519.svg";
export { ForwardRef as ReactComponent };